import script from "./createNewMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./createNewMedia.vue?vue&type=script&setup=true&lang=js"

import "./createNewMedia.vue?vue&type=style&index=0&id=20a66be0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20a66be0"]])

export default __exports__